import { Attribution } from "@endavaaccorplus/payments-common/schemas";

export const getChannelTypeAttribution = (origin?: Attribution["origin"]) => {
  switch (origin) {
    case "ACDC":
    case "qr-hotel-sale":
      return "Hotelsales";
    case "engage":
    case "zendesk":
      return "Telesales";
    case "partnership":
      return "Partnership";
    default:
      return "Online";
  }
};
